import { GeoDsComment } from './comment.model';
import { GeoDsDocument } from './document.model';
import { MailAddress } from './mail-address.model';
import { GeoDsMeta } from './meta-data.model';
import { Module } from './module.model';
import { Person } from './person.model';
import { PhoneNumber } from './phone-number.model';
import { WebAddress } from './web-address.model';

export class Address extends GeoDsMeta {
  Name: string;
  Name2: string;
  Reserve1: string;
  CustomerNumber: string;
  BusinessLine: string;
  Street: string;
  City: string;
  HouseNumber: string;
  Country: string;
  ZIP: string;
  Status: string;
  Phone: string;
  PhoneNumbers: PhoneNumber[];
  Phone2: string;
  Fax: string;
  FaxNumbers: PhoneNumber[];
  IdRefAddressParent: string;
  CompanyTitle: string;
  Homepage: string;
  EMail: string;
  MailAddress: MailAddress[];
  WebAddress: WebAddress[];
  MatchCode: string;
  Persons: Person[];
  Category: string;
  WebSite: string;
  Modules: Module[];
  Documents: GeoDsDocument[];
  NumberEmployees: string;
  Comments: GeoDsComment[];
  Comment: string;
  Sector: string;
  Locked: boolean;
  Dealer: boolean;
  CustomerSince: Date | string;
  Locations: Address[];
  Customer: boolean;
  Headquarters: boolean;
  Department: string;
  CustomerBeginDate: Date | string;
  LastStatusChanged: Date | string;
  Reserve5: string;
  LegalForm?: string;
  IdDetail?: string;
  DeliveryStop: boolean;
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
